export const indexedMap = <T>(entries?: Iterable<[string, string, T]>) => {
  const map = new Map<string, Map<string, T>>();

  const set = (firstId: string, secondId: string, value: T) => {
    const innerMap = map.get(firstId);
    if (innerMap) {
      innerMap.set(secondId, value);
    } else {
      map.set(firstId, new Map([[secondId, value]]));
    }
  };

  if (entries) {
    for (const [firstId, secondId, value] of entries) {
      set(firstId, secondId, value);
    }
  }

  return {
    get: (firstId: string, secondId: string) => map.get(firstId)?.get(secondId),
    set,
    delete: (firstId: string, secondId: string) => {
      const innerMap = map.get(firstId);
      innerMap?.delete(secondId);

      if (innerMap?.size === 0) {
        map.delete(firstId);
      }
    },
    getAll: (firstId: string) =>
      map.get(firstId) as ReadonlyMap<string, T> | undefined,
    deleteAll: (firstId: string) => {
      map.delete(firstId);
    },
    *[Symbol.iterator]() {
      for (const [firstId, innerMap] of map) {
        for (const [secondId, value] of innerMap) {
          yield [firstId, secondId, value] as [string, string, T];
        }
      }
    },
  };
};

export type IndexedMap<T> = ReturnType<typeof indexedMap<T>>;
